export default "https://cdn-static.gokick.com/assets/a922e5568f1cf4039f8565ae5776ec3d05b76040/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";